"use strict";
// Marketing contracts: attribution captured on the site, the owner's
// marketing settings, and the config the published-site runtime receives.
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeAttribution = sanitizeAttribution;
const ATTRIBUTION_STRING_KEYS = [
    'source',
    'medium',
    'campaign',
    'term',
    'content',
    'gclid',
    'fbclid',
    'ttclid',
    'msclkid',
    'referrer',
    'landingPath',
    'gaClientId',
    'fbp',
    'fbc',
    'userAgent',
    'eventId',
    'firstTouchAt',
];
/** Keep only known keys, short printable strings and a boolean consent pair. Untrusted input. */
function sanitizeAttribution(raw) {
    if (!raw || typeof raw !== 'object') {
        return undefined;
    }
    const input = raw;
    const out = {};
    for (const key of ATTRIBUTION_STRING_KEYS) {
        const v = input[key];
        if (typeof v === 'string' && v.trim()) {
            out[key] = v
                .replace(/[\u0000-\u001f<>"'`]/g, '')
                .trim()
                .slice(0, key === 'userAgent' ? 400 : 200);
        }
    }
    const consent = input.consent;
    if (consent && typeof consent === 'object') {
        out.consent = { analytics: consent.analytics === true, marketing: consent.marketing === true };
    }
    return Object.keys(out).length ? out : undefined;
}
// Owner routes (studio, `:id` = app id = chat id):
//   GET  /api/plugins/marketing/apps/:id                 → MarketingSettingsView
//   PUT  /api/plugins/marketing/apps/:id/tags/:provider  { enabled, values, secrets? } → TagConfigView
//   PUT  /api/plugins/marketing/apps/:id/consent         ConsentSettings
//   PUT  /api/plugins/marketing/apps/:id/whatsapp        WhatsAppSettings | { enabled:false }
//   PUT  /api/plugins/marketing/apps/:id/server-side     { enabled }
//   GET  /api/plugins/marketing/apps/:id/attribution?days=30&mode=live → AttributionRow[]
//   GET  /api/plugins/search-console/apps/:id            → SearchConsoleStatus
//   POST /api/plugins/search-console/apps/:id/connect    { returnUrl } → { url } (Google OAuth)
//   GET  /api/plugins/search-console/oauth/callback      (Google redirect; public)
//   POST /api/plugins/search-console/apps/:id/verify     → SearchConsoleStatus
//   POST /api/plugins/search-console/apps/:id/sitemap    → SearchConsoleStatus
//   GET  /api/plugins/search-console/apps/:id/performance?days=28 → SearchPerformance
//   POST /api/plugins/search-console/apps/:id/disconnect
//   GET  /api/plugins/email-marketing/apps/:id           → { provider, configured, triggers, lastSyncs[] }
//   PUT  /api/plugins/email-marketing/apps/:id           { provider, credentials?, triggers }
//   POST /api/plugins/email-marketing/apps/:id/test      → { ok, message }
//   GET  /api/plugins/reviews/apps/:id?status=pending    → ReviewView[]
//   POST /api/plugins/reviews/apps/:id/:reviewId/approve | /reject | /reply { reply }
